module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/vi_1-40a66d081510f7c99d9cbbdb8348b6e6.jpg";